import { SearchResult } from "../SearchResultRow/SearchResultRow.types";
import { getSearchResultRecordIdKey } from "./SearchResultRow.utils";

export const MAX_RECENT_SAVED_COUNT = 5;

export const getRecentSearchResultsStorageKey = (entityId: number) => {
  return `og_assist_recent_search_results_entity_${entityId}`;
};
export const getRecentlyViewedSearchResults = (entityId: number): SearchResult[] => {
  try {
    const savedJson = window.localStorage.getItem(getRecentSearchResultsStorageKey(entityId));
    if (!savedJson) return [];
    return JSON.parse(savedJson) as SearchResult[];
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const addToRecentlyViewedSearchResults = (entityId: number, record: SearchResult): void => {
  try {
    const saved = [...getRecentlyViewedSearchResults(entityId)];
    const idKey = getSearchResultRecordIdKey(record) as keyof SearchResult;
    const alreadySavedOnIdx = saved.findIndex((item) => item[idKey] === record[idKey]);
    if (alreadySavedOnIdx >= 0) saved.splice(alreadySavedOnIdx, 1);
    const updated = [record, ...saved].slice(0, MAX_RECENT_SAVED_COUNT);
    window.localStorage.setItem(getRecentSearchResultsStorageKey(entityId), JSON.stringify(updated));
  } catch (err) {
    console.error(err);
  }
};
